module.exports = __webpack_public_path__ + "static/b-a-1-before-82db081a13b220a392fffb17bfcdc3d5.jpg";